<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <help :text="$t('help.transaction_create')" :title="$t('help.transaction_create_title')"/>
    <div
      class="white-container">
      <TransactionView
        :fields="fields"
      />
    </div>
  </div>
</template>

<script>
  import fields from './transactionsCreationFields.js';
  import TransactionView from './TransactionView';

  export default {
    name: 'TransactionCreation',
    components: {
      TransactionView
    },
    data () {
      return {
        fields: fields
      }
    },
  }
</script>